module.exports = __webpack_public_path__ + "img/4.0db6ed50.jpg";